export default class CategoriaFinanceira {
  constructor(public codigo = "", public nome = "") {}
}
